export default 'page/events'
